module.exports = __webpack_public_path__ + "img/noon_icon.c203e424.svg";